import type { FsSynchronousApi } from '@jsonjoy.com/fs-node-utils';

export const fsSynchronousApiList: Array<keyof FsSynchronousApi> = [
  'accessSync',
  'appendFileSync',
  'chmodSync',
  'chownSync',
  'closeSync',
  'copyFileSync',
  'cpSync',
  'existsSync',
  'fchmodSync',
  'fchownSync',
  'fdatasyncSync',
  'fstatSync',
  'fsyncSync',
  'ftruncateSync',
  'futimesSync',
  'globSync',
  'lchmodSync',
  'lchownSync',
  'linkSync',
  'lstatSync',
  'mkdirSync',
  'mkdtempSync',
  'openSync',
  'opendirSync',
  'readdirSync',
  'readFileSync',
  'readlinkSync',
  'readSync',
  'readvSync',
  'realpathSync',
  'renameSync',
  'rmdirSync',
  'rmSync',
  'statfsSync',
  'statSync',
  'symlinkSync',
  'truncateSync',
  'unlinkSync',
  'utimesSync',
  'lutimesSync',
  'writeFileSync',
  'writeSync',
  'writevSync',
];
